import React, { use, useState } from "react";
import {
	TextField,
	Button,
	Paper,
	Typography,
	CircularProgress,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	CssBaseline,
} from "@mui/material";
import { motion } from "framer-motion";
import { styled } from "@mui/material/styles";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom"; // for navigation
// import axios from "../../api/axios"; // your axios instance
import axios from "../../api/axios";
// import { countries } from "../../data";
import { Link } from "react-router-dom";
import axiosLib from "axios";
import { jwtDecode } from "jwt-decode";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { GrUserAdmin } from "react-icons/gr";

const StyledPaper = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(4),
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	maxWidth: 400,
	margin: "auto",
	borderRadius: "20px",
	boxShadow: theme.shadows[5],
	transition: "transform 0.2s",
	"&:hover": {
		transform: "scale(1.03)",
	},
}));

const LoginForm = () => {
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [selectedCountry, setSelectedCountry] = useState("");
	const [error, setError] = useState(""); // For user-visible error messages
	const [loading, setLoading] = useState(false);
	const [successMsg, setSuccessMsg] = useState("");
	const { setAuth } = useAuth();
	// const axiosPrivate = useAxiosPrivate();

	const handleLogin = async (e) => {
		e.preventDefault();
		setError("");
		setSuccessMsg("");

		if (!validateEmail(email)) {
			setError("Please enter a valid email address.");
			return;
		}

		setLoading(true);
		try {
			const response = await axios.post(
				"/login",
				{
					email,
					password,
				},
				{
					withCredentials: true,
				}
			);

			setSuccessMsg("Login successful! Redirecting to dashboard...");
			// console.log(response);

			// capture
			if (response.status === 200) {
				const { accessToken } = response?.data;

				const userData = jwtDecode(accessToken);
				const {
					id,
					fullName,

					email,
				} = userData;

				console.log(userData);
				localStorage.setItem("accessToken", accessToken);
				setAuth((prev) => ({
					...prev,
					id,
					accessToken,
					fullName,
					email,
				}));

				setTimeout(() => {
					navigate("/dctdashboard/admin");
				}, 1500);
				// console.log({ isAdmin });
			}

			// setTimeout(() => {
			// 	navigate("/en/login");
			// }, 1500);
		} catch (err) {
			console.log(err);
			// Improved error handling
			// if (axiosLib.isAxiosError(err)) {
			// 	if (err.response && err.response.data) {
			// 		 Show server-sent error message if available
			// 		setError(err.response.data.message || "Registration failed");
			// 	} else if (err.message) {
			// 		 Network or other axios error
			// 		setError(err.message);
			// 	} else {
			// 		setError("An unknown error occurred");
			// 	}
			// } else {
			// 	setError("An unexpected error occurred");
			// }
		} finally {
			setLoading(false);
		}
	};

	const validateEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};

	return (
		<motion.div
			initial={{ opacity: 0, y: -30 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
			className="w-[90%] mx-auto">
			<StyledPaper elevation={3}>
				<Typography variant="h4" sx={{ fontWeight: "bold" }} gutterBottom>
					DTCL Admin
				</Typography>
				<Typography sx={{ color: "gray", fontSize: "0.9rem", mb: 2 }}>
					<GrUserAdmin className="inline-block  mr-[0.5rem]" />
					Admin secured login.
				</Typography>
				<form onSubmit={handleLogin} style={{ width: "100%" }} noValidate>
					<TextField
						label="Email"
						variant="outlined"
						fullWidth
						margin="normal"
						required
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<TextField
						label="Password"
						type="password"
						variant="outlined"
						fullWidth
						margin="normal"
						required
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					{/* <FormControl variant="outlined" fullWidth margin="normal" required>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							onChange={(e) => setSelectedCountry(e.target.value)}
							label="Country">
							{countries.map((country) => (
								<MenuItem key={country.code} value={country.name}>
									{country.name}
								</MenuItem>
							))}
						</Select>
					</FormControl> */}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						disabled={loading}
						sx={{ position: "relative" }}>
						{loading && (
							<CircularProgress
								size={24}
								sx={{
									position: "absolute",
									top: "50%",
									left: "50%",
									transform: "translate(-50%, -50%)",
								}}
							/>
						)}
						{!loading && "Login"}
					</Button>
					{error && (
						<Typography color="error" align="center" sx={{ mt: 2 }}>
							{error}
						</Typography>
					)}
					{successMsg && (
						<Typography color="primary" align="center" sx={{ mt: 2 }}>
							{successMsg}
						</Typography>
					)}
				</form>
				<Typography variant="body2" align="center" sx={{ mt: 2 }}>
					Forgot password?{" "}
					<Link to="/en/forgotpassword" className="text-blue-500">
						Reset Password Now
					</Link>
				</Typography>
				<Typography variant="body2" align="center" sx={{ mt: 2 }}>
					Dont have an account?{" "}
					<Link to="/en/register" className="text-blue-500">
						Register
					</Link>
				</Typography>
			</StyledPaper>
		</motion.div>
	);
};

const theme = createTheme({
	palette: {
		primary: { main: "#1976d2" },
		secondary: { main: "#dc004e" },
	},
});

export default function AdminLoginForm() {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					height: "100vh",
					backgroundColor: "#f5f5f5",
				}}>
				<LoginForm />
			</div>
		</ThemeProvider>
	);
}
